module.exports = __webpack_public_path__ + "img/cr2_3.db18503c.png";